var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKoruLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 38,
    viewBox: "0 0 245 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "67.53 54.83 65.28 47.89 63.02 54.83 67.53 54.83",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.49 23.95 109.03 34.37 111.17 34.37 116.69 23.93 116.69 37.35 119.84 37.35 119.84 18.42 116.63 18.42 110.13 30.83 103.63 18.42 100.37 18.42 100.37 37.35 103.49 37.35 103.49 23.95",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.27,
    y: 24.14,
    width: 3.34,
    height: 13.21,
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.03,
    y: 17.91,
    width: 3.8,
    height: 3.28,
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.38,30.04c0-.68.15-1.3.43-1.83.29-.54.7-.96,1.22-1.26.52-.3,1.12-.45,1.78-.45.59,0,1.08.11,1.46.34.38.23.66.57.84,1.02.18.44.26,1.01.26,1.69v7.8h3.34v-7.96c0-1.25-.18-2.29-.53-3.11-.35-.81-.89-1.42-1.59-1.81-.7-.39-1.6-.6-2.66-.6s-2,.26-2.82.76c-.74.44-1.3,1.08-1.73,1.95l-.18.36v-2.8h-3.15v13.21h3.34v-7.31Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.12,36.77c.88.56,1.93.85,3.12.85,1.1,0,2.06-.27,2.86-.8.72-.48,1.24-1.13,1.6-2.01l.18-.44v2.98h3.12v-18.93h-3.34v8.34l-.18-.37c-.36-.75-.85-1.32-1.5-1.74-.78-.51-1.73-.77-2.81-.77-1.17,0-2.21.29-3.08.85-.88.57-1.57,1.37-2.05,2.39-.49,1.02-.74,2.24-.74,3.63s.25,2.59.74,3.62c.49,1.03,1.18,1.83,2.07,2.4Zm1.49-9.25c.64-.74,1.51-1.12,2.58-1.12s1.96.38,2.59,1.12c.63.74.94,1.82.94,3.23s-.32,2.48-.94,3.23c-.63.76-1.5,1.15-2.59,1.15s-1.94-.38-2.58-1.14c-.64-.75-.96-1.84-.96-3.23s.32-2.5.96-3.23Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.16,37.35h3.31v-10.73h3.35v5.51c0,1.23.18,2.26.55,3.06.36.8.91,1.41,1.64,1.81.73.41,1.65.61,2.73.61s1.96-.26,2.71-.78c.62-.43,1.14-1.03,1.54-1.8l.18-.34v2.65h3.15v-13.21h-3.34v7.36c0,.66-.14,1.27-.42,1.79-.28.53-.67.95-1.16,1.24-.49.3-1.06.45-1.69.45-.57,0-1.06-.11-1.44-.32-.39-.22-.67-.55-.85-.99-.18-.43-.26-.96-.26-1.57v-7.96h-6.68v-.58c0-.61.11-1.12.32-1.5.21-.38.55-.68.99-.88.43-.19.98-.31,1.65-.35l1.47-.08-.23-2.5-1.4.08c-2.06.11-3.62.64-4.62,1.58-.98.92-1.48,2.31-1.5,4.13v.09h-2.6v2.47h2.6v10.73Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.05,37.35v-7.96c0-1.25-.18-2.29-.53-3.11-.35-.81-.89-1.42-1.59-1.81-.7-.39-1.6-.6-2.66-.6s-2,.26-2.82.76c-.74.44-1.3,1.08-1.73,1.95l-.18.36v-2.8h-3.15v10.57h-1.39c-.43,0-.8-.1-1.11-.28-.3-.19-.53-.47-.69-.83-.15-.35-.22-.79-.22-1.31v-14.14h-3.34v14.36c0,1.58.38,2.79,1.14,3.61.75.82,1.91,1.23,3.43,1.23h5.51v-7.31c0-.68.15-1.3.43-1.83.29-.54.7-.96,1.22-1.26.52-.3,1.11-.45,1.78-.45.59,0,1.08.11,1.46.34.38.23.66.57.84,1.02.18.44.26,1.01.26,1.69v7.8h3.34Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.07,36.79c1.11.55,2.47.83,4.04.83.93,0,1.88-.14,2.83-.42.93-.27,1.72-.65,2.36-1.15l-.9-2.21c-.6.44-1.27.76-1.98.95-.75.2-1.5.3-2.23.3-.95,0-1.76-.16-2.43-.47-.67-.32-1.17-.81-1.51-1.47-.21-.4-.35-.9-.43-1.48v-.11s9.77,0,9.77,0v-.96c0-1.39-.26-2.6-.76-3.6-.5-1-1.23-1.78-2.15-2.32-.92-.54-2.03-.81-3.29-.81-1.35,0-2.55.3-3.56.9-1.01.59-1.8,1.41-2.37,2.43-.56,1.02-.84,2.21-.84,3.55,0,1.4.3,2.64.88,3.67.59,1.03,1.44,1.83,2.55,2.38Zm-.26-7.22c.07-.56.2-1.05.4-1.47.31-.63.74-1.12,1.3-1.46.55-.34,1.22-.51,1.97-.51,1.07,0,1.91.33,2.5.99.5.56.79,1.39.85,2.45v.1s-7.03,0-7.03,0v-.11Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.64,34.85c-.48.27-1.2.41-2.15.41-.54,0-1.11-.05-1.7-.15-.58-.1-1.15-.26-1.7-.47-.51-.19-.98-.43-1.41-.69l-.86,2.19c.43.32.94.58,1.5.78.61.22,1.28.39,1.98.51.71.13,1.47.19,2.23.19,1.18,0,2.21-.17,3.07-.5.85-.33,1.53-.8,2.01-1.42.47-.62.71-1.36.71-2.22,0-1-.31-1.8-.92-2.38-.62-.59-1.57-1-2.82-1.21l-2.79-.49c-.58-.1-1-.26-1.28-.5-.28-.24-.43-.58-.43-1.01,0-.52.24-.94.72-1.23.47-.29,1.19-.43,2.14-.43.48,0,.98.05,1.48.16.51.11,1.01.27,1.48.47.43.18.81.4,1.15.66l.9-2.18c-.38-.32-.83-.58-1.35-.79-.54-.22-1.13-.4-1.77-.51-.63-.12-1.28-.18-1.92-.18-1.19,0-2.24.18-3.11.54-.87.35-1.54.84-1.99,1.46-.46.61-.69,1.34-.69,2.17,0,.95.3,1.74.9,2.37.6.63,1.49,1.05,2.66,1.25l2.85.49c.63.09,1.09.25,1.38.48.3.23.46.58.46,1.02,0,.52-.25.93-.74,1.21Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.94,31.1c-.62-.59-1.57-1-2.83-1.21l-2.79-.49c-.58-.1-1-.26-1.28-.5-.28-.24-.43-.58-.43-1.01,0-.52.24-.94.72-1.23.47-.29,1.18-.43,2.14-.43.48,0,.98.05,1.48.16.51.11,1.01.27,1.48.47.43.18.82.41,1.14.66l.9-2.18c-.38-.32-.83-.59-1.35-.79-.54-.22-1.13-.4-1.77-.51-.63-.12-1.28-.18-1.92-.18-1.19,0-2.24.18-3.11.54-.87.35-1.54.84-1.99,1.46-.46.61-.69,1.34-.69,2.17,0,.95.3,1.74.9,2.37.6.63,1.49,1.05,2.66,1.25l2.85.49c.63.09,1.09.25,1.38.48.3.23.46.58.46,1.02,0,.52-.25.93-.74,1.21-.47.27-1.2.41-2.15.41-.53,0-1.11-.05-1.7-.15-.58-.1-1.15-.26-1.7-.47-.12-.05-.25-.09-.39-.14-.43-.16-.91-.33-1.27-.53-.05.72-.28,1.42-.67,2.11.48.35,1.05.66,1.57.85.61.22,1.27.39,1.98.51.71.13,1.47.19,2.24.19,1.18,0,2.21-.17,3.07-.5.86-.33,1.53-.81,2-1.42.47-.62.71-1.36.71-2.22,0-1-.31-1.8-.92-2.38Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.38,
    y: 42.82,
    width: 3.39,
    height: 18.93,
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.84,61.75v-7.96c0-1.25-.18-2.29-.53-3.11-.35-.81-.89-1.42-1.59-1.81-.7-.39-1.6-.6-2.66-.6s-2,.26-2.82.76c-.73.44-1.31,1.1-1.73,1.95l-.18.36v-2.8h-3.15v13.21h3.34v-7.31c0-.68.15-1.3.43-1.83s.7-.96,1.22-1.26c.52-.3,1.11-.45,1.78-.45.59,0,1.08.11,1.46.34.38.23.66.57.84,1.02.18.44.26,1.01.26,1.69v7.8h3.34Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.24,51.09v-2.55h-4.31v-3.88h-3.23v3.88h-6.18v13.21h3.34v-10.65h2.74v5.68c0,1.7.44,3.02,1.32,3.91.87.89,2.22,1.34,4.01,1.34.58,0,1.08-.05,1.54-.16.78-.19,1.37-.46,1.87-.87-.1-.17-.37-.61-.51-1.01-.13-.38-.26-.82-.33-1.1-.31.13-.76.23-1.08.3-.3.06-.62.1-.93.1-.87,0-1.52-.22-1.94-.67-.41-.44-.62-1.11-.62-2v-5.51h4.31Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.81,61.86c.48-.1.88-.24,1.33-.45.23-.11.5-.32.65-.5-.25-.26-.5-.61-.72-.93l-.07-.09c-.12-.17-.38-.64-.49-.88-.17.04-.5.13-.74.18-.3.06-.62.1-.93.1-.87,0-1.52-.22-1.94-.67-.41-.44-.62-1.11-.62-2v-5.51h4.31v-2.55h-4.31v-3.88h-3.23v3.88h-6.09v7.36c0,.66-.14,1.27-.42,1.79-.28.53-.67.95-1.16,1.24-.49.3-1.06.45-1.69.45-.57,0-1.06-.11-1.44-.32-.39-.22-.68-.55-.85-1-.17-.43-.26-.96-.26-1.57v-7.96h-3.34v7.99c0,1.23.18,2.26.55,3.06.36.8.91,1.41,1.64,1.81.73.41,1.65.61,2.73.61s1.96-.26,2.71-.78c.62-.43,1.14-1.03,1.54-1.8l.18-.34v2.65h3.15v-10.65h2.65v5.68c0,1.7.44,3.02,1.31,3.91.87.89,2.22,1.34,4.01,1.34.51,0,1.03-.05,1.54-.16Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.6,61.6c.93-.27,1.72-.65,2.37-1.15l-.9-2.21c-.59.43-1.26.75-1.98.95-.75.2-1.5.3-2.23.3-.95,0-1.77-.16-2.43-.47-.66-.31-1.17-.81-1.51-1.47-.2-.4-.35-.9-.42-1.48v-.11s9.77,0,9.77,0v-.96c0-1.39-.26-2.6-.76-3.6-.5-1-1.22-1.78-2.14-2.32-.92-.54-2.03-.81-3.29-.81-1.35,0-2.55.3-3.56.89-1.01.59-1.8,1.41-2.36,2.43-.56,1.02-.84,2.22-.84,3.55s.28,2.54.83,3.55l.13.22c.58.98,1.42,1.75,2.48,2.27,1.11.55,2.47.83,4.04.83.93,0,1.88-.14,2.83-.42Zm-7.13-7.63c.07-.57.2-1.05.4-1.47.31-.63.74-1.12,1.3-1.46.55-.34,1.22-.51,1.97-.51,1.07,0,1.91.33,2.49.99.5.56.79,1.39.85,2.45v.1s-7.03,0-7.03,0v-.11Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.28,
    y: 42.31,
    width: 3.8,
    height: 3.28,
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.37,59.28c-.87,0-1.53-.22-1.94-.67-.41-.44-.62-1.11-.62-2v-5.51h4.31v-2.55h-4.31v-3.88h-3.34v12.11c0,1.7.44,3.02,1.31,3.91.87.89,2.22,1.34,4.01,1.34.51,0,1.03-.05,1.54-.16.51-.11.95-.26,1.32-.45,0,0,.12-.06.27-.15v-2.54c-.38.15-.7.23-.71.23-.55.16-1.2.33-1.84.33Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.16,61.52c.86-.33,1.53-.8,2.01-1.42.47-.61.71-1.36.71-2.22,0-1-.31-1.8-.92-2.38-.62-.59-1.56-1-2.82-1.21l-2.79-.49c-.57-.09-1-.26-1.28-.5-.28-.24-.43-.58-.43-1.01,0-.52.24-.94.72-1.23.46-.29,1.18-.43,2.14-.43.48,0,.97.05,1.48.16.51.11,1.01.27,1.48.47.43.18.81.41,1.14.67l.9-2.18c-.38-.32-.83-.58-1.35-.79-.54-.22-1.14-.4-1.77-.51-.63-.12-1.28-.18-1.92-.18-1.19,0-2.24.18-3.11.54-.87.35-1.54.84-1.99,1.46-.46.61-.69,1.34-.69,2.17,0,.95.3,1.75.9,2.38.6.63,1.49,1.05,2.66,1.25l2.85.49c.62.09,1.09.25,1.38.48.3.23.46.58.46,1.02,0,.52-.25.93-.74,1.21-.47.27-1.2.41-2.15.41-.54,0-1.11-.05-1.7-.15-.58-.1-1.15-.26-1.7-.47-.5-.19-.98-.42-1.41-.69l-.85,2.19c.43.32.94.58,1.5.78.59.21,1.26.38,1.98.51.71.13,1.47.19,2.23.19,1.18,0,2.21-.17,3.07-.5Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.9 79.26 122.04 79.26 122.04 78.17 117.16 78.17 117.16 75.01 121.76 75.01 121.76 73.92 117.16 73.92 117.16 70.89 122.04 70.89 122.04 69.81 115.9 69.81 115.9 79.26",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.78 76.38 125.35 69.81 124.09 69.81 124.09 79.26 125.3 79.26 125.3 72 128.33 77.78 129.2 77.78 132.23 71.97 132.23 79.26 133.42 79.26 133.42 69.81 132.19 69.81 128.78 76.38",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.64 79.26 141.78 79.26 141.78 78.17 136.9 78.17 136.9 75.01 141.49 75.01 141.49 73.92 136.9 73.92 136.9 70.89 141.78 70.89 141.78 69.81 135.64 69.81 135.64 79.26",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.85,75.4c-.2-.15-.44-.22-.69-.25.41-.06.8-.15,1.12-.32.42-.22.74-.52.96-.9.22-.38.33-.84.33-1.38,0-.88-.28-1.56-.83-2.04-.55-.47-1.34-.71-2.36-.71h-3.9v9.45h1.29v-3.9h1.65c.28,0,.52.02.72.07.2.05.38.14.54.27.16.13.3.32.42.56l1.59,2.99h1.42l-1.65-3.07c-.19-.36-.39-.62-.61-.78Zm-1.63-1.08h-2.45v-3.44h2.43c.71,0,1.23.14,1.58.42.35.28.52.71.52,1.28s-.17,1.02-.52,1.31c-.34.29-.86.44-1.56.44Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.54,75.28h2.33v2.61c-.27.09-.54.19-.84.25-.41.08-.84.12-1.29.12-1.13,0-1.98-.31-2.55-.94-.58-.62-.86-1.55-.86-2.77s.28-2.11.84-2.75c.56-.63,1.36-.95,2.41-.95.56,0,1.08.08,1.54.23.46.16.91.41,1.34.77l.47-1.01c-.26-.25-.56-.46-.91-.63-.35-.17-.73-.3-1.14-.39s-.84-.13-1.3-.13c-.96,0-1.78.19-2.47.58-.69.39-1.21.94-1.58,1.67-.37.72-.55,1.59-.55,2.6s.18,1.88.55,2.6.9,1.28,1.61,1.66c.71.38,1.56.58,2.56.58.39,0,.79-.03,1.21-.09.41-.06.8-.14,1.17-.23.37-.1.68-.21.94-.35v-4.46h-3.46v1.03Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.11,
    y: 69.81,
    width: 1.29,
    height: 9.45,
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.24 77.2 166.67 69.81 165.61 69.81 165.61 79.26 166.83 79.26 166.83 71.88 172.39 79.26 173.45 79.26 173.45 69.81 172.24 69.81 172.24 77.2",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.84,75.28h2.33v2.61c-.27.09-.54.19-.84.25-.41.08-.84.12-1.29.12-1.13,0-1.98-.31-2.55-.94-.58-.62-.86-1.55-.86-2.77s.28-2.11.84-2.75c.56-.63,1.36-.95,2.41-.95.56,0,1.08.08,1.54.23.46.16.91.41,1.34.77l.47-1.01c-.26-.25-.56-.46-.91-.63-.35-.17-.73-.3-1.14-.39-.41-.09-.84-.13-1.3-.13-.96,0-1.78.19-2.47.58-.69.39-1.21.94-1.58,1.67-.37.72-.55,1.59-.55,2.6s.18,1.88.55,2.6c.37.72.9,1.28,1.61,1.66.71.38,1.56.58,2.56.58.39,0,.79-.03,1.21-.09.41-.06.8-.14,1.17-.23.37-.1.68-.21.94-.35v-4.46h-3.46v1.03Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.89,69.81l-4.18,9.45h1.33l.98-2.3h4.85l.99,2.3h1.33l-4.18-9.45h-1.11Zm.54,1.45h.04l1.96,4.62h-3.96l1.96-4.62Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.39,70.36c-.71-.37-1.58-.55-2.6-.55h-3.34v9.45h3.34c1.02,0,1.88-.18,2.6-.55.71-.37,1.26-.9,1.63-1.61.38-.71.56-1.56.56-2.57s-.19-1.86-.56-2.57c-.37-.7-.92-1.23-1.63-1.6Zm-.05,6.89c-.59.6-1.48.9-2.65.9h-1.96v-7.25h1.96c1.17,0,2.05.3,2.65.9.59.6.89,1.51.89,2.72s-.3,2.12-.89,2.73Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.66,75.49c0,.92-.21,1.6-.64,2.05-.43.45-1.06.67-1.89.67s-1.46-.22-1.9-.67c-.43-.45-.65-1.13-.65-2.05v-5.68h-1.3v5.71c0,1.27.33,2.23.98,2.88.66.65,1.61.98,2.86.98s2.19-.33,2.84-.98c.65-.65.98-1.61.98-2.88v-5.71h-1.29v5.68Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.38 69.81 218.1 69.81 218.1 79.26 224.13 79.26 224.13 78.13 219.38 78.13 219.38 69.81",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.19 70.92 226.56 70.92 226.56 79.26 227.85 79.26 227.85 70.92 231.23 70.92 231.23 69.81 223.19 69.81 223.19 70.92",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.46,74.18l-1.46-.28c-.59-.12-1.01-.29-1.25-.52-.25-.23-.37-.53-.37-.92,0-.35.1-.64.29-.88.19-.24.46-.43.8-.56.34-.13.74-.2,1.2-.2.55,0,1.06.08,1.51.24.45.16.87.42,1.25.78l.46-1.02c-.26-.25-.55-.46-.88-.62-.33-.17-.69-.29-1.08-.38-.39-.08-.8-.13-1.24-.13-.7,0-1.31.12-1.86.35-.54.23-.96.56-1.27.97-.31.42-.46.9-.46,1.47,0,.68.2,1.23.6,1.65.4.42,1.03.71,1.89.88l1.47.29c.42.09.76.19,1.02.31.26.12.46.26.58.44.12.17.18.39.18.65,0,.47-.19.85-.57,1.13-.38.28-.94.42-1.69.42-.44,0-.85-.04-1.23-.11-.38-.07-.73-.18-1.07-.33s-.65-.33-.95-.56l-.44,1.03c.29.24.63.44,1.01.6.38.16.79.28,1.24.36.45.08.93.12,1.44.12.72,0,1.35-.12,1.88-.35.53-.23.94-.56,1.23-.97.29-.42.44-.9.44-1.44,0-.65-.22-1.17-.66-1.57-.44-.39-1.11-.68-2.01-.87Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.68,74.05h-1.38l.13-.78c.09-.54.29-.93.98-.93h.48v.78h.63l.25-1.37s-.68-.2-1.37-.2c-1.22,0-1.77.78-1.94,1.9l-.1.59-.94.1-.1.63h.92l-.75,4.78c-.12.73-.41,1.2-1,1.2h-.69l-.17.62s.47.13.81.13c1.26,0,1.81-.93,2-2.15l.73-4.59h1.37l.13-.73Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.36,73.91c-1.69,0-2.87,1.39-2.87,3.44,0,1.17.68,1.93,1.8,1.93,1.68,0,2.91-1.32,2.91-3.44,0-1.11-.63-1.92-1.83-1.92Zm-.9,4.59c-.59,0-1-.34-1-1.12,0-1.42.58-2.68,1.72-2.68.59,0,1.04.29,1.04,1.12,0,1.56-.63,2.68-1.77,2.68Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.3,74.32c-.44.35-.73.87-.95,1.38l.38-1.7c-.41.01-.82.02-1.23.03-.11,0-.49-.05-.56.02-.08.07-.08.43-.09.53.28.07.55.13.83.2-.24,1.46-.48,2.93-.71,4.39.31,0,.62,0,.93,0,.1-.67.19-1.35.38-2.01.18-.66.45-1.3.87-1.84.21-.27.48-.53.82-.54,0,.23,0,.46,0,.68h.63c.1-.49.2-.98.29-1.46-.52-.21-1.15-.04-1.59.31Z",
    style: {
      fill: "#3d4a4a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.63,
    cy: 50,
    r: 40.48,
    style: {
      fill: "#85b740",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.48 62.49 29.79 62.49 29.79 63.85 34.03 63.85 34.03 41.83 32.48 41.83 32.48 62.49",
    style: {
      fill: "#61862d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.25 62.49 14.51 62.49 14.51 63.85 18.79 63.85 18.79 51.8 17.25 47.75 17.25 62.49",
    style: {
      fill: "#61862d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.28 51.84 19.45 41.83 18.42 41.83 22.77 53.18 23.28 51.84",
    style: {
      fill: "#61862d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.96 58.71 22.46 58.71 22.98 60.07 25.51 60.07 28.24 52.97 28.24 47.58 23.96 58.71",
    style: {
      fill: "#61862d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.08 62.49 37.07 62.49 37.07 63.85 41.63 63.85 41.63 41.83 40.08 41.83 40.08 62.49",
    style: {
      fill: "#61862d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.49 53.15 47.49 58.87 49.03 58.87 49.03 54.51 56.75 54.51 56.75 50.89 55.2 50.89 55.2 53.15 47.49 53.15",
    style: {
      fill: "#61862d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.49 44.1 47.49 49.53 49.03 49.53 49.03 45.45 57.4 45.45 57.4 41.83 55.85 41.83 55.85 44.1 47.49 44.1",
    style: {
      fill: "#61862d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.4 61.23 57.4 60.23 55.85 60.23 55.85 62.49 44.66 62.49 44.66 63.85 57.4 63.85 57.4 62.49 56.93 62.49 57.4 61.23",
    style: {
      fill: "#61862d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.07 48.18 67.11 45.22 67.05 45.22 64.14 54.15 66.13 54.15 68.07 48.18",
    style: {
      fill: "#61862d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.87 63.85 70.59 41.83 69.56 41.83 77.32 62.49 73.77 62.49 74.21 63.85 78.87 63.85",
    style: {
      fill: "#61862d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.03 57.77 61.52 62.49 58.99 62.49 58.48 63.85 63.07 63.85 64.58 59.13 71.57 59.13 71.13 57.77 63.03 57.77",
    style: {
      fill: "#61862d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.48 41.83 32.48 40.47 27.61 40.47 23.28 51.84 22.77 53.18 18.42 41.83 17.9 40.47 12.97 40.47 12.97 62.49 14.51 62.49 17.25 62.49 17.25 47.75 18.79 51.8 21.43 58.71 22.46 58.71 23.96 58.71 28.24 47.58 28.24 52.97 28.24 62.49 29.79 62.49 32.48 62.49 32.48 41.83",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.08 41.83 40.08 40.47 35.52 40.47 35.52 62.49 37.07 62.49 40.08 62.49 40.08 41.83",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.85 60.23 55.85 58.87 49.03 58.87 47.49 58.87 47.49 53.15 55.2 53.15 55.2 50.89 55.2 49.53 49.03 49.53 47.49 49.53 47.49 44.1 55.85 44.1 55.85 41.83 55.85 40.47 43.11 40.47 43.11 62.49 44.66 62.49 55.85 62.49 55.85 60.23",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.56,41.83l-.51-1.36h-3.84l-7.8,20.76-.47,1.26h4.59l1.52-4.72h8.09l.44,1.36,1.1,3.36h4.65l-7.76-20.66Zm-2.51,3.39h.06l.96,2.96,1.94,5.97h-5.87l2.9-8.93Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoruLogo);
export default __webpack_public_path__ + "static/media/KoruLogo.05839fa22a02f2d8ae1b67c5afce80d9.svg";
export { ForwardRef as ReactComponent };